import server from "../Utils/request.js";

//登录
export function login(data) {
	return server({
		url: '/admin/login',
		method: 'post',
		data
	})
}
//验证码
export function verify(data) {
	return server({
		url: '/admin/verify',
		method: 'get',
		responseType: 'blob'
	})
}
//单图片上传
export function up_img(data) {
	return server({
		url: '/admin/up/img',
		method: 'post',
		data
	})
}
//首页数据
export function index_data(data) {
	return server({
		url: 'admin/index/data',
		method: 'get'
	})
}
//合同临期列表
export function contract_endtime(data) {
	return server({
		url: 'admin/index/contract/endtime',
		method: 'get'
	})
}

//提醒忽略
export function msg_hl(data) {
	return server({
		url: '/admin/index/msg/hl',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 用户管理////////
///////////////////////////

//新建管理员
export function administrator_create(data) {
	return server({
		url: '/admin/administrator/create',
		method: 'post',
		data
	})
}
//管理员列表
export function administrator_list(data) {
	return server({
		url: '/admin/administrator/list',
		method: 'post',
		data
	})
}
//管理员状态
export function administrator_switch(data) {
	return server({
		url: '/admin/administrator/switch',
		method: 'post',
		data
	})
}
//管理员编辑
export function administrator_edit(data) {
	return server({
		url: '/admin/administrator/edit',
		method: 'post',
		data
	})
}
//管理员密码修改
export function administrator_changepwd(data) {
	return server({
		url: '/admin/administrator/changepwd',
		method: 'post',
		data
	})
}
//个人信息修改
export function administrator_aloneEdit(data) {
	return server({
		url: '/admin/administrator/aloneEdit',
		method: 'post',
		data
	})
}
//个人密码修改
export function administrator_aloneChangePwd(data) {
	return server({
		url: '/admin/administrator/aloneChangePwd',
		method: 'post',
		data
	})
}
//绑定微信公众号
export function administrator_bind_wx_qrcode(data) {
	return server({
		url: '/admin/administrator/bind/wx/qrcode',
		method: 'post',
		data
	})
}
//接收推送
export function administrator_set_ismsg(data) {
	return server({
		url: '/admin/administrator/set/ismsg',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 条款////////
///////////////////////////
//新建条款
export function clause_create(data) {
	return server({
		url: '/admin/clause/create',
		method: 'post',
		data
	})
}
//条款列表
export function clause_list(data) {
	return server({
		url: '/admin/clause/list',
		method: 'post',
		data
	})
}
//条款编辑
export function clause_edit(data) {
	return server({
		url: '/admin/clause/edit',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 系统参数////////
///////////////////////////
//新建系统参数
export function param_create(data) {
	return server({
		url: '/admin/param/create',
		method: 'post',
		data
	})
}
//系统参数列表
export function param_list(data) {
	return server({
		url: '/admin/param/list',
		method: 'post',
		data
	})
}
//编辑系统参数
export function param_edit(data) {
	return server({
		url: '/admin/param/edit',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// banner图////////
///////////////////////////
//创建banner图
export function banner_create(data) {
	return server({
		url: '/admin/banner/create',
		method: 'post',
		data
	})
}
//banner图列表
export function banner_list(data) {
	return server({
		url: '/admin/banner/list',
		method: 'post',
		data
	})
}
//编辑banner图
export function banner_edit(data) {
	return server({
		url: '/admin/banner/edit',
		method: 'post',
		data
	})
}
//banner图状态
export function banner_switch(data) {
	return server({
		url: '/admin/banner/switch',
		method: 'post',
		data
	})
}
//删除banner图
export function banner_complete_delete(data) {
	return server({
		url: '/admin/admin/banner/complete/delete',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 房源管理////////
///////////////////////////
//创建房源
export function house_create(data) {
	return server({
		url: '/admin/house/create',
		method: 'post',
		data
	})
}
//房源列表
export function house_list(data) {
	return server({
		url: '/admin/house/list',
		method: 'post',
		data
	})
}
//编辑房源
export function house_edit(data) {
	return server({
		url: '/admin/house/edit',
		method: 'post',
		data
	})
}
//删除房源
export function house_delete(data) {
	return server({
		url: '/admin/house/delete',
		method: 'post',
		data
	})
}
//密码修改记录
export function pwdlog_list(data) {
	return server({
		url: '/admin/pwdlog/list',
		method: 'post',
		data
	})
}
//删除密码修改记录
export function pwdlog_delete(data) {
	return server({
		url: '/admin/pwdlog/delete',
		method: 'post',
		data
	})
}
//获取门锁数据
export function get_door_lock() {
	return server({
		url: '/admin/get/door/lock',
		method: 'get'
	})
}
//获取房态数据
export function get_room_status() {
	return server({
		url: '/admin/index/house/status/data',
		method: 'get'
	})
}
////////////////////////////
/////////// 合同管理////////
///////////////////////////
//获取未出租房源
export function get_house(data) {
	return server({
		url: '/admin/contract/get/house',
		method: 'get'
	})
}
//新建合同
export function contract_create(data) {
	return server({
		url: '/admin/contract/create',
		method: 'post',
		data
	})
}
//合同列表
export function contract_list(data) {
	return server({
		url: '/admin/contract/list',
		method: 'post',
		data
	})
}
//合同删除
export function contract_delete(data) {
	return server({
		url: '/admin/contract/delete',
		method: 'post',
		data
	})
}
//合同编辑
export function contract_edit(data) {
	return server({
		url: '/admin/contract/edit',
		method: 'post',
		data
	})
}
//合同换房
export function contract_change_room(data) {
	return server({
		url: '/admin/contract/change/room',
		method: 'post',
		data
	})
}
//合同换人
export function contract_change_tenant(data) {
	return server({
		url: '/admin/contract/change/tenant',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 续租管理////////
///////////////////////////
//续租列表
export function contract_reletList(data) {
	return server({
		url: '/admin/contract/reletList',
		method: 'post',
		data
	})
}
//续租删除
export function contract_reletDelete(data) {
	return server({
		url: '/admin/contract/reletDelete',
		method: 'post',
		data
	})
}
//续租申请
export function contract_relet_create(data) {
	return server({
		url: '/admin/contract/relet/create',
		method: 'post',
		data
	})
}
//续租审核
export function contract_relet_review(data) {
	return server({
		url: '/admin/contract/relet/review',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 退租管理////////
///////////////////////////
//退租列表
export function contract_outlist(data) {
	return server({
		url: '/admin/contract/outlist',
		method: 'post',
		data
	})
}
//退租编辑
export function contract_outEdit(data) {
	return server({
		url: '/admin/contract/outEdit',
		method: 'post',
		data
	})
}
//退租删除
export function contract_outDelete(data) {
	return server({
		url: '/admin/contract/outDelete',
		method: 'post',
		data
	})
}
//退租审核
export function contract_out_review(data) {
	return server({
		url: '/admin/contract/out/review',
		method: 'post',
		data
	})
}
//退租审核
export function contract_out_create(data) {
	return server({
		url: '/admin/contract/out/create',
		method: 'post',
		data
	})
}

////////////////////////////
/////////// 活动管理////////
///////////////////////////
//创建活动
export function activity_create(data) {
	return server({
		url: '/admin/activity/create',
		method: 'post',
		data
	})
}
//活动列表
export function activity_list(data) {
	return server({
		url: '/admin/activity/list',
		method: 'post',
		data
	})
}
//编辑活动
export function activity_edit(data) {
	return server({
		url: '/admin/activity/edit',
		method: 'post',
		data
	})
}
//删除活动
export function activity_delete(data) {
	return server({
		url: '/admin/activity/delete',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 优惠券种类////////
///////////////////////////
//创建优惠券种类
export function couponspecies_create(data) {
	return server({
		url: '/admin/couponspecies/create',
		method: 'post',
		data
	})
}
//优惠券种类列表
export function couponspecies_list(data) {
	return server({
		url: '/admin/couponspecies/list',
		method: 'post',
		data
	})
}
//编辑优惠券种类
export function couponspecies_edit(data) {
	return server({
		url: '/admin/couponspecies/edit',
		method: 'post',
		data
	})
}
//删除优惠券种类
export function couponspecies_hard_delete(data) {
	return server({
		url: '/admin/couponspecies/hard/delete',
		method: 'post',
		data
	})
}
//优惠券种类状态
export function couponspecies_switch(data) {
	return server({
		url: '/admin/couponspecies/switch',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 优惠券////////
///////////////////////////
//获取优惠券
export function coupon_get_coupon(data) {
	return server({
		url: '/admin/coupon/get/coupon',
		method: 'GET',
		data
	})
}
//创建优惠券
export function coupon_create(data) {
	return server({
		url: '/admin/coupon/create',
		method: 'post',
		data
	})
}
//优惠券列表
export function coupon_list(data) {
	return server({
		url: '/admin/coupon/list',
		method: 'post',
		data
	})
}
//编辑优惠券
export function coupon_edit(data) {
	return server({
		url: '/admin/coupon/edit',
		method: 'post',
		data
	})
}
//删除优惠券
export function coupon_hard_delete(data) {
	return server({
		url: '/admin/coupon/hard/delete',
		method: 'post',
		data
	})
}
//优惠券状态
export function coupon_switch(data) {
	return server({
		url: '/admin/coupon/switch',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 用户管理////////
///////////////////////////
//获取以出租房源
export function user_get_rent(data) {
	return server({
		url: '/admin/user/get/rent',
		method: 'GET',
		data
	})
}
//创建用户
export function user_create(data) {
	return server({
		url: '/admin/user/create',
		method: 'post',
		data
	})
}
//用户列表
export function user_list(data) {
	return server({
		url: '/admin/user/list',
		method: 'post',
		data
	})
}
//编辑用户
export function user_edit(data) {
	return server({
		url: '/admin/user/edit',
		method: 'post',
		data
	})
}
//删除用户
export function user_hard_delete(data) {
	return server({
		url: '/admin/user/hard/delete',
		method: 'post',
		data
	})
}
//用户状态
export function user_switch(data) {
	return server({
		url: '/admin/user/switch',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 报修管理////////
///////////////////////////
//报修列表
export function repair_list(data) {
	return server({
		url: '/admin/repair/list',
		method: 'post',
		data
	})
}
//编辑报修
export function repair_edit(data) {
	return server({
		url: '/admin/repair/edit',
		method: 'post',
		data
	})
}
//删除报修
export function repair_hard_delete(data) {
	return server({
		url: '/admin/repair/hard/delete',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 进出记录////////
///////////////////////////
//进出列表
export function comeOutLog_list(data) {
	return server({
		url: '/admin/comeOutLog/list',
		method: 'post',
		data
	})
}
//删除进出记录
export function comeOutLog_delete(data) {
	return server({
		url: '/admin/comeOutLog/delete',
		method: 'post',
		data
	})
}
////////////////////////////
/////////// 账单管理////////
///////////////////////////
//账单列表
export function bill_list(data) {
	return server({
		url: '/admin/bill/list',
		method: 'post',
		data
	})
}
//补齐账单
export function bill_replenish(data) {
	return server({
		url: '/admin/bill/replenish',
		method: 'post',
		data
	})
}
// //导出账单
export function bill_export(data) {
	return server({
		url: '/admin/bill/export',
		method: 'post',
		data,
		responseType: 'blob'
	})
}
////////////////////////////
/////////// 账单管理////////
///////////////////////////
//订单列表
export function bill_info(data) {
	return server({
		url: '/admin/bill/info',
		method: 'post',
		data
	})
}
//生成订单
export function bill_create(data) {
	return server({
		url: '/admin/bill/create',
		method: 'post',
		data
	})
}
//订单编辑
export function bill_edit(data) {
	return server({
		url: '/admin/bill/edit',
		method: 'post',
		data
	})
}
//订单删除
export function bill_delete(data) {
	return server({
		url: '/admin/bill/delete',
		method: 'post',
		data
	})
}
//发送提醒
export function send_msg(data) {
	return server({
		url: '/admin/bill/send/msg',
		method: 'post',
		data
	})
}
//后台支付
export function back_pay(data) {
	return server({
		url: `/admin/bill/back/pay/${data}`,
		method: 'get',
	})
}
////////////////////////////
/////////// 大门门禁////////
///////////////////////////
//设备列表
export function gate_list(data) {
	return server({
		url: '/admin/gate/list',
		method: 'post',
		data
	})
}
//添加设备
export function gate_create(data) {
	return server({
		url: '/admin/gate/create',
		method: 'post',
		data
	})
}
//大门人员列表
export function people_list(data) {
	return server({
		url: '/admin/people/list',
		method: 'post',
		data
	})
}
//新增大门人员
export function people_create(data) {
	return server({
		url: '/admin/people/create',
		method: 'post',
		data
	})
}
//编辑大门人员
export function people_edit(data) {
	return server({
		url: '/admin/people/edit',
		method: 'post',
		data
	})
}
//删除大门人员
export function people_delete(data) {
	return server({
		url: '/admin/people/delete',
		method: 'post',
		data
	})
}
//大门人员详情
export function people_info(data) {
	return server({
		url: `/admin/people/info/${data}`,
		method: 'get',
	})
}
//电表列表
export function energy_list(data) {
	return server({
		url: '/admin/energy/list',
		method: 'post',
		data
	})
}
//新增电表
export function energy_create(data) {
	return server({
		url: '/admin/energy/create',
		method: 'post',
		data
	})
}
//编辑电表
export function energy_edit(data) {
	return server({
		url: '/admin/energy/edit',
		method: 'post',
		data
	})
}
//删除电表
export function energy_delete(data) {
	return server({
		url: '/admin/energy/delete',
		method: 'post',
		data
	})
}
//电表详情
export function energy_look(data) {
	return server({
		url: `/admin/energy/look`,
		method: 'post',
		data
	})
}
//电表详情
export function energy_info(data) {
	return server({
		url: `/admin/energy/info/${data}`,
		method: 'get',
	})
}




//水表列表
export function water_list(data) {
	return server({
		url: '/admin/water/list',
		method: 'post',
		data
	})
}
//新增水表
export function water_create(data) {
	return server({
		url: '/admin/water/create',
		method: 'post',
		data
	})
}
//编辑水表
export function water_edit(data) {
	return server({
		url: '/admin/water/edit',
		method: 'post',
		data
	})
}
//删除水表
export function water_delete(data) {
	return server({
		url: '/admin/water/delete',
		method: 'post',
		data
	})
}
//查看水表
export function water_look(data) {
	return server({
		url: `/admin/water/look`,
		method: 'post',
		data
	})
}
//水表详情
export function water_info(data) {
	return server({
		url: `/admin/water/info/${data}`,
		method: 'get',
	})
}

////////////////////////////
/////////// 门锁管理////////
///////////////////////////
//门锁密码初始化
export function lock_init(data) {
	return server({
		url: `/admin/lock/init/${data}`,
		method: 'get'
	})
}
//门锁列表
export function lock_list(data) {
	return server({
		url: '/admin/lock/list',
		method: 'post',
		data
	})
}
//门锁密码修改
export function lock_pwd_change(data) {
	return server({
		url: '/admin/lock/pwd/change',
		method: 'post',
		data
	})
}
//修改门锁名称
export function lock_name_change(data) {
	return server({
		url: '/admin/lock/name/change',
		method: 'post',
		data
	})
}
// 门锁绑定房间
export function lock_bind_room(data) {
	return server({
		url: '/admin/lock/bind/room',
		method: 'post',
		data
	})
}

////////////////////////////
/////////// 智能水电表////////
///////////////////////////

//获取所有水电表
export function get_meters_list(data) {
	return server({
		url: '/admin/get/meters/list',
		method: 'post',
		data
	})
}
//绑定房间
export function bind_meters_room(data) {
	return server({
		url: '/admin/bind/meters/room',
		method: 'post',
		data
	})
}
//查看抄表记录
export function look_meters_num(data) {
	return server({
		url: '/admin/look/meters/num',
		method: 'post',
		data
	})
}
//阀门开关
export function meters_switch_action(data) {
	return server({
		url: '/admin/meters/switch/action',
		method: 'post',
		data
	})
}
//充值
export function meters_top_up(data) {
	return server({
		url: '/admin/meters/top/up',
		method: 'post',
		data
	})
}
export function test_one() {
	return server({
		url: '/app/my/gate/open/door/error',
		method: 'get'
	})
}

// 操作日志
export function operate_list(data) {
	return server({
		url: '/admin/system/operate/list',
		method: 'post',
		data
	})
}

// 系统日志
export function log_list(data) {
	return server({
		url: '/admin/system/log/list',
		method: 'post',
		data
	})
}
